// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const deviceInfo = (function () {
  const _w = window;

  const getDoc = () => document.documentElement;
  const getBody = () => document.body || document.documentElement;

  return {
    screenWidth(): number {
      return Math.max(
        0,
        _w.innerWidth || getDoc().clientWidth || getBody().clientWidth || 0,
      );
    },
    screenHeight(): number {
      return Math.max(
        0,
        _w.innerHeight || getDoc().clientHeight || getBody().clientHeight || 0,
      );
    },
    screenCenterX(): number {
      return this.screenWidth() / 2;
    },
    screenCenterY(): number {
      return this.screenHeight() / 2;
    },
    pixelRatio(): number {
      return _w.devicePixelRatio;
    },
    mouseX(e: MouseEvent): number {
      return Math.max(0, e.clientX || 0);
    },
    mouseY(e: MouseEvent): number {
      return Math.max(0, e.clientY || 0);
    },
    mouseCenterX(e: MouseEvent): number {
      return this.mouseX(e) - this.screenCenterX();
    },
    mouseCenterY(e: MouseEvent): number {
      return this.mouseY(e) - this.screenCenterY();
    },
    getScrollPercent(): number {
      const doc = getDoc();
      const body = getBody();
      const scrollTop =
        window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
      const scrollHeight = Math.max(
        body.scrollHeight,
        doc.scrollHeight,
        body.offsetHeight,
        doc.offsetHeight,
        body.clientHeight,
        doc.clientHeight,
      );
      const clientHeight = window.innerHeight || doc.clientHeight;
      const denominator = scrollHeight - clientHeight;

      return denominator > 0 ? (scrollTop / denominator) * 100 : 0;
    },
    getScrollY(): number {
      const doc = getDoc();
      const body = getBody();
      return window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
    },
    getScrollHeight(): number {
      const doc = getDoc();
      const body = getBody();
      return Math.max(
        body.scrollHeight,
        body.offsetHeight,
        doc.scrollHeight,
        doc.offsetHeight,
        doc.clientHeight,
      );
    },
  };
})();
